import _extends from "@babel/runtime/helpers/esm/extends";

/* eslint-disable import/order */
// This file has been generated using @svgr/cli.
// Run "yarn generate:icons" in order to generate the files for new icons.
import * as React from 'react';
import styled from 'styled-components';
import { size, color } from 'styled-system';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.233 6.818c0 .452.367.818.818.818H33A7.364 7.364 0 0 1 40.364 15v18.02a.818.818 0 1 0 1.636 0V15a9 9 0 0 0-9-9H15.051a.818.818 0 0 0-.818.818ZM8.017 36.222c-.254-3.239-.38-6.486-.38-9.742 0-3.252.126-6.638.38-10.16a4.09 4.09 0 0 1 4.096-3.797c3.698.015 6.85.023 9.456.023 2.592 0 5.858-.008 9.796-.023 2.26-.008 4.098 1.816 4.107 4.107a2571.379 2571.379 0 0 0 0 19.258 4.09 4.09 0 0 1-3.798 4.096c-3.51.253-6.887.38-10.128.38-3.257 0-6.513-.128-9.77-.383a4.09 4.09 0 0 1-3.759-3.759Zm-1.633-20.02A143.477 143.477 0 0 0 6 26.48c0 3.298.129 6.588.386 9.87a5.727 5.727 0 0 0 5.263 5.262c3.299.259 6.598.388 9.897.388 3.281 0 6.697-.128 10.246-.383a5.727 5.727 0 0 0 5.316-5.736 2609.708 2609.708 0 0 1 0-19.288 5.727 5.727 0 0 0-5.749-5.706c-3.937.015-7.2.022-9.79.022-2.604 0-5.753-.007-9.449-.022a5.727 5.727 0 0 0-5.736 5.316Z",
    fill: "currentColor"
  }));
};

var SvgCopy = styled(SvgComponent).withConfig({
  displayName: "Copy__SvgCopy",
  componentId: "sc-h202on-0"
})(["", " ", ""], size, color);
export default SvgCopy;